import React, { useCallback } from "react";

import { useOffer } from "../../../../hooks/offer";

import { CustomButtom } from "../../../../components/BotaoCTA/styles";

import { useSelector } from "react-redux";

import {
  Wrapper,
  TextIntro,
  TitleContainer,
  Title,
  ContainerCTA,
  Container,
  Content,
  Background
} from "./style";

const selector = state => ({
  component: state.component
});

export default function Banner() {
  const { currentOffer } = useOffer();

  const { component } = useSelector(selector);
  const {
    bannerBgImage,
    bannerTitle,
    bannerTitleColor,
    bannerMessage,
    bannerMessageColor,
    bannerPrimaryBtnColor,
    bannerPrimaryBtnTextColor,
    bannerSecondaryBtnColor,
    bannerSecondaryBtnTextColor,
    bannerPrimaryText,
    bannerSecondaryText,
    hasPrimmaryBtn,
    hasSecondaryBtn,
    secondaryBorderBtn
  } = component;

  const scrollToOffer = useCallback(() => {
    const el = document.querySelector("#plans");
    const yOffset = -80;
    const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({ top: y, behavior: "smooth" });
  }, []);

  const openLink = () => {
    window.open("https://veloe.com.br/sobre", "_blank").focus();
  };

  return (
    <Wrapper>
      <Container>
        <Background src={"https://" + bannerBgImage} />
        <Content>
          {currentOffer && currentOffer.intro ? (
            <TextIntro
              cor={bannerMessageColor}
              tamanho="Grande"
              dangerouslySetInnerHTML={{ __html: currentOffer.intro }}
            />
          ) : (
            <TextIntro cor={bannerMessageColor}>{bannerMessage}</TextIntro>
          )}
          <TitleContainer>
            <Title tamanho="Grande" cor={bannerTitleColor}>
              {currentOffer && currentOffer.title
                ? currentOffer.title
                : bannerTitle}
            </Title>
          </TitleContainer>
          <div>
            {hasPrimmaryBtn === true && (
              <ContainerCTA>
                <CustomButtom
                  color="primary"
                  label={bannerPrimaryText}
                  onBg="light"
                  onClick={scrollToOffer}
                  style={{
                    backgroundColor: bannerPrimaryBtnTextColor,
                    color: bannerPrimaryBtnColor,
                    border: undefined
                  }}
                />
              </ContainerCTA>
            )}
            {hasSecondaryBtn === true && (
              <ContainerCTA>
                <CustomButtom
                  color="primary"
                  label={bannerSecondaryText}
                  onBg="light"
                  onClick={openLink}
                  style={{
                    backgroundColor: bannerSecondaryBtnColor,
                    color: bannerSecondaryBtnTextColor,
                    border: `1px solid ${secondaryBorderBtn}`
                  }}
                />
              </ContainerCTA>
            )}
          </div>
        </Content>
      </Container>
    </Wrapper>
  );
}
